var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5833333333333334,0,0,0.5833333333333334,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.93,16.6l-.56-.21a.53.53,0,0,1-.14-.3,2.58,2.58,0,0,1,.06-1.3,5.61,5.61,0,0,0,1.46-4.31A3.66,3.66,0,0,0,17,6.5a3.93,3.93,0,0,0-1.62.35.25.25,0,0,0-.14.22,8.72,8.72,0,0,1-1.69,5.35.25.25,0,0,0-.05.22,5.62,5.62,0,0,0,.26.73.32.32,0,0,0,.14.14c2.44.89,5.6,2.39,5.6,7V22c0,.07,0,.15,0,.22a.25.25,0,0,0,.06.2.23.23,0,0,0,.18.08H23.5A.5.5,0,0,0,24,22v-.85C24,18.05,21.84,17.28,19.93,16.6Z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,20.5c0-3.95-2.77-4.93-5.22-5.81L12,14.43c-.07,0-.17-.14-.24-.4a3.35,3.35,0,0,1,.08-1.95c.95-1,1.87-2.33,1.87-5.53,0-3.49-2.38-5-4.75-5S4.25,3.06,4.25,6.55c0,3.2.92,4.49,1.87,5.52a3.4,3.4,0,0,1,.08,2c-.07.26-.17.37-.24.4l-.76.27C2.76,15.56,0,16.54,0,20.5V22a.5.5,0,0,0,.5.5h17A.5.5,0,0,0,18,22Z",
    style: {
      fill: "current"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntern);
export default __webpack_public_path__ + "static/media/intern.b3d14936ca934762db89fd45d33b8c93.svg";
export { ForwardRef as ReactComponent };